import { Stack, Typography } from '@mui/material';
import { RefreshButton } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import useVehicleOrdersForApproval from '../hooks/useVehicleOrdersForApproval';

export default function Header() {
  const { t } = useTranslation('approvals');
  const { refresh } = useVehicleOrdersForApproval();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack>
        <Typography variant="h6">{t('approvals')}</Typography>
        <Typography variant="body1" color="text.secondary">
          {t('clickOnARow')}
        </Typography>
      </Stack>
      <RefreshButton onClick={refresh} />
    </Stack>
  );
}
